import React, { useEffect } from 'react';

import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import {
  blue,
  primarycolor,
  secondaryButtonnBackground
} from '../../../constants/Colors';
import { buttonFont, cardCentering } from '../../../constants/Location';
import CompleteCard from '../../uiParts/CompleteCard';
import Header from '../../uiParts/Header';

const styles = {
  button: {
    '@media screen and (max-width:480px)': {
      width: 309
    },
    height: 42,
    width: 400
  },
  buttonFont,
  mailIcon: {
    color: blue,
    fontSize: '56px',
    paddingBottom: '24px'
  }
};

const PasswordRestSendmail: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('title.common.passwordResetComplete');
  });

  const url = new URL(window.location.href);
  const params = url.searchParams;
  const mail = params.get('email')?.split('?').join('') ?? '';

  const mailIcon = <EmailOutlinedIcon sx={styles.mailIcon} />;
  const text = t('passwordReset.sendMailText');
  const description = t('passwordReset.sendMailDescription', { mail });

  const backPage = (): void => {
    window.history.back();
  };

  const button = (
    <Button
      variant="contained"
      sx={[secondaryButtonnBackground, styles.button]}
      onClick={() => {
        backPage();
      }}
    >
      <Typography component="div" color={primarycolor} sx={styles.buttonFont}>
        {t('passwordReset.back')}
      </Typography>
    </Button>
  );

  return (
    <>
      <Header />
      <Typography sx={cardCentering} component="div">
        <CompleteCard
          icon={mailIcon}
          text={text}
          description={description}
          button={button}
        />
      </Typography>
    </>
  );
};

export default PasswordRestSendmail;
